// import axios from 'axios';
import axios from '../config/axios'

const getAuthToken = () => localStorage.getItem('authToken');

const addAuthTokenToHeaders = (headers = {}) => {
  if (typeof headers !== 'object' || headers === null) {
    headers = {};
  }

  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    headers['userType'] = 'admin';
  }

  return headers;
};

export const postRequest = ({ url, params, headers, data }) =>
  axios({
    method: 'POST',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    data,
  });

const abortControllers = new Map();

// In-flight GETs are deduped so a newer request for the same thing cancels the older one — which
// is what stops a retyped search box racing its own earlier response. The key is the PATH, so two
// query strings on one path collide: fired together, the second silently aborts the first and its
// caller gets null. Pass `abortKey` when the query names a different resource rather than a
// refinement of the same one (`?kind=campaign` vs `?kind=template`).
export const getRequest = async ({ url, params, headers, isAbort=true, abortKey }) => {
  const urlKey = abortKey || url.split('?')[0];

  if (abortControllers.has(urlKey) && isAbort) {
    abortControllers.get(urlKey).abort();
  }

  const controller = new AbortController();
  abortControllers.set(urlKey, controller);

  try {
    const response = await axios({
      method: 'GET',
      url,
      params,
      headers:addAuthTokenToHeaders(headers),
      signal: controller.signal,
    });
    return response;
  } catch (err) {
    if (err.name === 'CanceledError') {
      return null; 
    }
    throw err;
  } finally {
    abortControllers.delete(urlKey);
  }
};

export const putRequest = ({ url, params, headers, data }) =>
  axios({
    method: 'PUT',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    data,
  });

export const deleteRequest = ({ url, params, headers }) =>
  axios({
    method: 'DELETE',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
  });

export const patchRequest = ({ url, params, headers, data }) =>
  axios({
    method: 'PATCH',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    data,
  });
